import React, { memo } from "react";
import { View, Text } from "react-native";
import { useSelector } from "react-redux";

import { MarkdownText } from "components";
import { fillPlaceholders } from "state/modules/survey/selectors";

import { styles } from "./styles";

export const DescriptionHeading = memo(
  ({ heading, style }) => {
    const text = useSelector(state => fillPlaceholders(heading, state));
    return (
      <View style={[styles.containerStyle, style]}>
        <Text style={style}>
          <MarkdownText>{text}</MarkdownText>
        </Text>
      </View>
    );
  },
  () => true,
);
